import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { press } from '../../data/content';
export function PressList() {
  return <section aria-labelledby="press-title" className="w-full bg-paper text-ink" data-id="element-115" data-mp="58t37pt9avie">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 md:px-10 lg:grid-cols-12 lg:py-28" data-id="element-116" data-mp="3ndwe5r5wm1qq">
        <div className="lg:col-span-4" data-id="element-117" data-mp="3rf88g9zq3b59">
          <h2 id="press-title" className="font-serif text-5xl leading-[1.02] tracking-tight" data-id="element-118" data-mp="3dp4pbrw53xk1">
            Gehoord &amp; gezien in het Gooi.
          </h2>
          <p className="mt-5 max-w-sm text-[17px] leading-relaxed text-ink/70" data-id="element-119" data-mp="3igmpweu93w4h">
            Van de radio in Laren tot het podium op de Huizer Brugparade.
          </p>
        </div>
        <ul className="border-t border-ink/15 lg:col-span-8" data-id="element-120" data-mp="38p9vbfh2irur">
          {press.map(item => <li key={item.href} className="border-b border-ink/15" data-id="element-121" data-mp="2uq0kywfjmryp">
              <a href={item.href} target="_blank" rel="noopener noreferrer" className="group grid grid-cols-1 gap-2 py-6 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-deep sm:grid-cols-12 sm:items-baseline sm:gap-6" data-id="element-122" data-mp="2zpdcvvl9up85">
                <span className="text-sm font-semibold sm:col-span-3" data-id="element-123" data-mp="qf2ii6ix36bc">{item.source}</span>
                <span className="font-serif text-2xl leading-snug transition-colors duration-150 group-hover:text-amber-deep sm:col-span-6" data-id="element-124" data-mp="lfpon1tmoyz9">
                  {item.title}
                </span>
                <span className="flex items-center justify-between gap-3 text-sm text-ink/60 sm:col-span-3 sm:justify-end" data-id="element-125" data-mp="3owg8aji4vajf">
                  {item.date}
                  <ArrowUpRightIcon aria-hidden className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-126" data-mp="7h9jvgfbtijr" />
                  <span className="sr-only" data-id="element-127" data-mp="3b404vhlblahz">(opent in nieuw venster)</span>
                </span>
              </a>
            </li>)}
        </ul>
      </div>
    </section>;
}